import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class RepresentativeUser
{
	constructor(token)
	{
		this.backend = new Backend(token);
  }

  editUser(data, callback)
  {
    this.backend.callBackend(`${Endpoints.representativeUsers.private}`, callback, 'PUT', data)
  }

  disableRepresentativeUser(purchaserid, userId, callback)
  {
    this.backend.callBackend(`${Endpoints.representativeUsers.private}/purchaser/${purchaserid}/${userId}`, callback, 'PUT')
  }
  
  addUserToGroups(userId, data, callback)
  {
    this.backend.callBackend(`${Endpoints.representativeUsers.user}/${userId}/groups/add`, callback, 'PUT', data)
  }

  removeUserFromGroups(userId, data, callback)
  {
    this.backend.callBackend(`${Endpoints.representativeUsers.user}/${userId}/groups/remove`, callback, 'PUT', data)
  }
}